<template>

    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <v-row align="center" >
                        <v-col cols="12" lg="2" md="2" sm="12">
                            <v-icon left>mdi-cash-fast</v-icon>
                            Checkout
                        </v-col>
                        <v-col cols="12" lg="2" md="2" sm="12">
                            <v-text-field
                                v-model="checkoutPagination.search"
                                class="mr-3"
                                label="Buscar"
                                placeholder="Informe o nome do cliente"
                                hide-details
                                @keydown="buscar()"
                                clearable
                                @input="checkoutPagination.search = $event ? $event : ''"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="3" md="4" sm="12">
                            <v-select
                                v-model="checkoutPagination.status"
                                :items="checkoutStatusList"
                                label="Status"
                                hide-details
                                item-text="name"
                                item-value="id"
                                clearable
                                @change="buscar()"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="2" sm="12">
                            <v-menu
                                ref="menu1"
                                v-model="menu1"
                                :close-on-content-click="false"
                                transition="scale-transition"

                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="dateFormattedStart"
                                        label="Data Inícial"
                                        placeholder="Informe uma data para busca."
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        hide-details
                                        @blur="startDate = parseDate(dateFormattedStart)"
                                        @focusout="startDate = parseDate(dateFormattedStart)"
                                        v-on="on"
                                        v-mask="['##/##/####']"
                                        clearable
                                        @input="dateFormattedStart = $event ? $event : ''"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="startDate"
                                    no-title
                                    @input="menu1 = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2" sm="12">
                            <v-menu
                                ref="menu2"
                                v-model="menu2"
                                :close-on-content-click="false"
                                transition="scale-transition"

                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="dateFormattedEnd"
                                        label="Data Final"
                                        placeholder="Informe uma data para busca."
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        hide-details
                                        @blur="endDate = parseDate(dateFormattedEnd)"
                                        @focusout="endDate = parseDate(dateFormattedEnd)"
                                        v-on="on"
                                        v-mask="['##/##/####']"
                                        clearable
                                        @input="dateFormattedEnd = $event ? $event : ''"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="endDate"
                                    no-title
                                    @input="menu2 = false"
                                    :min="startDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" lg="1" md="2" sm="12">
                            <v-btn
                                class="btn-new"
                                @click="buscar()"
                            >
                                <v-icon >mdi-magnify</v-icon>
                                <span class="d-md-none" >Pesquisar</span>
                            </v-btn>
                        </v-col>
                    </v-row>

                </v-card-title>
                <v-alert type="warning" outlined v-show="!checkouts"
                >Nenhum usuário encontrado.
                </v-alert
                >


                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="filteredCheckoutsItems()"
                    :options.sync="options"
                    :server-items-length="checkouts.totalItems"
                    :search="checkoutPagination.search"
                    item-key="id"
                    class="elevation-1"
                    v-show="checkouts"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >
                    <template v-slot:item.value="{ item }">
                        {{ item.value | money }}
                    </template>
                    <!--<template v-slot:item.bsBMs="{ item }">-->
                    <!-- <span v-for="(bm, index) in item.bsBMs" :key="bm.id+'bm'">-->
                    <!--  {{ bm.name }}<span v-if="index != item.bsBMs.length - 1">, </span>-->
                    <!-- </span>-->
                    <!--</template>-->
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{ name: 'checkoutPerson', params: { id: item.id } }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>

</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";

import {CHECKOUT_SEARCH, CHECKOUT_STATUS_LIST_GET} from "@/store/actions/checkout.type";
import {CHECKOUT_RESET_STATE, SET_CHECKOUT_PAGINATION} from "@/store/mutations/checkout.type";


export default {
    name: "checkout",
    directives: {mask},
    props: {
        source: String
    },

    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.dispatch(CHECKOUT_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            store.dispatch(CHECKOUT_RESET_STATE),
            store.dispatch(CHECKOUT_STATUS_LIST_GET),
        ]).then(() => {
            next();
        });
    },
    async beforeDestroy() {
        if(!this.$route.path.includes('/checkout')){
            localStorage.removeItem('checkoutOptions')
        }
    },
    data: () => ({
        //Lista de Usuários
        pagination: {
            sortBy: "name"
        },
        ativo: true,

        options: {},

        selected: [],
        headers: [
            {
                text: "Nome",
                align: "left",
                value: "name"
            },
            // { text: "Instituição", value: "instituicao" },
            {text: "Telefone", value: "phone"},
            {text: "Usuário Lyndus", value: "app_user"},
            // {text: "Profissionais", value: "bsBMs"},
            {text: "Visualizar", value: "actions", sortable: false}
        ],

        startDate: "",//(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        endDate: "",//(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dateFormattedStart: null,
        dateFormattedEnd: null,
        menu1: false,
        menu2: false,

        formIsValid: false,

        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        // cpfRule: [
        //     v => !!v || "CPF é obrigatório",
        //     strCPF => {
        //         if (!strCPF) return false;
        //         strCPF = strCPF.replace(/\D/g, "");
        //         let Soma;
        //         let Resto;
        //         Soma = 0;
        //         if (strCPF == "00000000000") return "CPF Inválido";
        //         let i = 0;
        //         for (i = 1; i <= 9; i++)
        //             Soma =
        //                 Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        //         Resto = (Soma * 10) % 11;
        //
        //         if (Resto == 10 || Resto == 11) Resto = 0;
        //         if (Resto != parseInt(strCPF.substring(9, 10)))
        //             return "CPF Inválido";
        //
        //         Soma = 0;
        //         for (i = 1; i <= 10; i++)
        //             Soma =
        //                 Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        //         Resto = (Soma * 10) % 11;
        //
        //         if (Resto == 10 || Resto == 11) Resto = 0;
        //         if (Resto != parseInt(strCPF.substring(10, 11)))
        //             return "CPF Inválido";
        //         return true;
        //     }
        // ],
        // emailRules: [
        //     v => !!v || "E-mail é obrigatório",
        //     value => {
        //         if (typeof value !== "undefined" && value.length > 0) {
        //             const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //             return pattern.test(value) || "Informe um email válido";
        //         }
        //         return false;
        //     }
        // ]
    }),
    methods: {

        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        //Methods Lista Usuarios
        toggleAll() {
            if (this.selected.length) this.selected = [];
            else this.selected = this.dados.slice();
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        buscar() {
            
            const {sortBy, sortDesc, itemsPerPage, page} = this.options

            store.commit(SET_CHECKOUT_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0],
                startDate: this.startDate,
                endDate: this.endDate
            })
            store.dispatch(CHECKOUT_SEARCH);
        },

        reset() {
            this.$refs.formUsuario.reset();
        },

        filteredCheckoutsItems() { 
            const items = this.checkouts.items
            const search = this.checkoutPagination.search.toLowerCase()
            if(search){
                this.options.itemsPerPage = this.checkouts.totalItems
                this.options.page = 1
                const exactMatches = [];
                const partialMatches = [];

                items.forEach(item => {
                    const itemValues = Object.values(item).map(value => String(value).toLowerCase());
                    const isExactMatch = itemValues.some(value => value.startsWith(search));
                    const isPartialMatch = itemValues.some(value => value.includes(search));
                    
                    if (isExactMatch) {
                        exactMatches.push(item);
                    } else if (isPartialMatch) {
                        partialMatches.push(item);
                    }
                });

                return [...exactMatches,...partialMatches];
            }
            else if(!search || search == '') {
                if(this.options.itemsPerPage == this.checkouts.totalItems){
                    this.options.itemsPerPage = 10
                    this.options.search = ''
                }
                return items;
            } 
        }
    },
    mounted() {
        if (localStorage.getItem('checkoutOptions')){
            this.options = JSON.parse(localStorage.getItem('checkoutOptions'))
        }
    },
    watch: {
        options: {
            handler(newOptions) {
                this.buscar()
                const parsed = JSON.stringify(newOptions)
                localStorage.setItem('checkoutOptions', parsed)
            },
            deep: true,
        },
        startDate() {
            this.dateFormattedStart = this.formatDate(this.startDate)
        },
        endDate() {
            this.dateFormattedEnd = this.formatDate(this.endDate)
        },
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["checkouts", "checkUsers", "checkoutStatusList", "checkoutPagination"])
    },
};
</script>
